import React, { useState } from 'react';

import { ClickAwayListener, IconButton } from '@material-ui/core';
import { MenuItem, Select } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { ReactComponent as FilterIcon } from 'pages/Teachers/ClassroomInsights/assets/filter-icon.svg';
import { ReactComponent as SearchIcon } from 'pages/Teachers/Home/assets/search-icon.svg';

import styles from './styles.module.scss';

const useStyles = makeStyles((theme) => ({
  selectRoot: {
    height: '36px',
    backgroundColor: '#F8F7FF',
    borderRadius: '10px',
    border: '1.5px solid #E0D9F7',
    padding: '4px 12px',
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      borderColor: '#D1C4E9',
      backgroundColor: '#F3F0FF'
    },
    '&:before, &:after': {
      display: 'none'
    }
  },
  selectIcon: {
    color: '#6A61A1',
    right: '4px'
  },
  inputText: {
    color: '#6A61A1',
    fontSize: '14px',
    fontWeight: 400,
    fontFamily: 'inherit',
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
  }
}));

const progressOptions = [
  { key: 'met', name: 'Met' },
  { key: 'approaching', name: 'Approaching' },
  { key: 'not_yet', name: 'Not Yet' },
  { key: 'not_started', name: 'Not Started' }
];

const GoalsSearchAndFilter = ({
  onSearchChange,
  value,
  progress,
  onProgressChange
}) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const [progressOpen, setProgressOpen] = useState(false);

  const classes = useStyles();

  const hasActiveFilters = progress !== '';

  const handleFiltersReset = () => {
    onProgressChange('');
    setFiltersOpen(false);
  };

  return (
    <ClickAwayListener onClickAway={() => setFiltersOpen(false)}>
      <div className={styles.searchWrapper}>
        <div className={styles.searchInput}>
          <IconButton
            className={styles.filterBtn}
            onClick={() => setFiltersOpen(!filtersOpen)}
          >
            <FilterIcon />
          </IconButton>

          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search Goals here..."
            value={value}
            onClick={() => setFiltersOpen(false)}
            onChange={(e) => {
              setFiltersOpen(false);
              onSearchChange(e.target.value);
            }}
          />

          <SearchIcon className={styles.searchIcon} />
        </div>

        {filtersOpen && (
          <div className={styles.filters}>
            <Select
              open={progressOpen}
              onClose={() => setProgressOpen(false)}
              onOpen={() => setProgressOpen(true)}
              value={progress || 'placeholder'}
              onChange={(e) => {
                onProgressChange(e.target.value);
                setFiltersOpen(false);
              }}
              IconComponent={ExpandMoreIcon}
              className={classes.selectRoot}
              classes={{
                select: classes.inputText,
                icon: classes.selectIcon
              }}
              MenuProps={{ disablePortal: true }}
            >
              <MenuItem value="placeholder" disabled>
                Progress
              </MenuItem>
              {progressOptions.map(({ key, name }) => (
                <MenuItem key={key} value={key} className={classes.menuItem}>
                  {name}
                </MenuItem>
              ))}
            </Select>
            <button
              className={styles.resetFiltersBtn}
              onClick={handleFiltersReset}
              disabled={!hasActiveFilters}
            >
              Reset filters
            </button>
          </div>
        )}
      </div>
    </ClickAwayListener>
  );
};

export default GoalsSearchAndFilter;
